import { render } from "./ButtonSelection.vue?vue&type=template&id=0849788d&scoped=true&ts=true"
import script from "./ButtonSelection.ts?vue&type=script&lang=ts"
export * from "./ButtonSelection.ts?vue&type=script&lang=ts"

import "./ButtonSelection.scss?vue&type=style&index=0&id=0849788d&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0849788d"]])

export default __exports__